import React, { useEffect, useState } from "react";
import PieData from "./pie";
import BarData from "./bar";
import LineData from "./line";
import TableData from "./table";
import DashboardData from "./dashboardData";
import Scatter from "./scatter";
import MapData from "./map";
import { Empty } from "antd";

function EchartsData(props) {
  const {
    type,
    data = {},
    drillable,
    qsycData,
    question_id,
    drillActions,
    changSpining,
  } = props;
  console.log(data, "搜索条件返回来的数据是啥");
  const [newData, setNewData] = useState(data);
  useEffect(() => {
    // 建议加一个判断，防止 data 为空对象时覆盖有效数据（可选，视具体业务逻辑而定）
    if (data && Object.keys(data).length > 0) {
      setNewData({
        ...data,
      });
    }
  }, [data]); // <--- 将 data 加入依赖数组
  return (
    <>
      {data?.data ? (
        <>
          {type == "line" ? (
            <LineData
              data={newData}
              drillable={drillable}
              qsycData={qsycData}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type == "bar" ? (
            <BarData
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type == "pie" ? (
            <PieData
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type == "table" ? (
            <TableData
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type === "dashboard" ? (
            <DashboardData
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type === "scatter" ? (
            <Scatter
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
          {type === "map" ? (
            <MapData
              data={newData}
              drillable={drillable}
              question_id={question_id}
              drillActions={drillActions}
              changSpining={(val) => {
                changSpining(val);
              }}
            />
          ) : undefined}
        </>
      ) : (
        <Empty />
      )}
    </>
  );
}

export default EchartsData;
